import React from "react";
import { useNavigate } from "react-router-dom";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  white: "#FFFFFF",
  muted: "#6B85A3",
};

interface PaywallCardProps {
  icon: string;
  title: string;
  description: string;
  ctaLabel?: string;
  variant?: "white" | "navy";
  pricingParams?: string;
}

export default function PaywallCard({
  icon,
  title,
  description,
  ctaLabel = "Débloquer le plan Pro →",
  variant = "white",
  pricingParams,
}: PaywallCardProps) {
  const navigate = useNavigate();
  const isNavy = variant === "navy";

  return (
    <div
      className="rounded-xl p-6 text-center"
      style={{
        backgroundColor: isNavy ? C.navy : C.white,
        border: isNavy ? "none" : `1px solid #D6E4F0`,
      }}
    >
      <span className="text-4xl block mb-3">{icon}</span>
      <h3
        className="text-base font-bold mb-2"
        style={{ color: isNavy ? C.white : C.navy }}
      >
        {title}
      </h3>
      <p
        className="text-sm mb-4 max-w-sm mx-auto"
        style={{ color: isNavy ? "#8BAAC8" : C.muted }}
      >
        {description}
      </p>
      <button
        onClick={() => navigate(pricingParams ? `/pricing?${pricingParams}` : "/pricing?cycle=annual")}
        className="px-6 py-2.5 rounded-xl text-sm font-bold text-white transition-opacity hover:opacity-90"
        style={{ backgroundColor: C.teal }}
      >
        {ctaLabel}
      </button>
      <p
        className="text-xs mt-2"
        style={{ color: isNavy ? "rgba(139,170,200,.7)" : C.muted, opacity: 0.8 }}
      >
        à partir de 39€/mois (annuel)
      </p>
    </div>
  );
}
